import { ChatPromptInputType } from 'utils/chat/chatConstants';
import ChatPromptContinue from './ChatPromptContinue';
import ChatPromptDecision from './ChatPromptDecision';
import ChatPromptFrame from './ChatPromptFrame';

const PromptComponentByInputType = {
    [ChatPromptInputType.BINARY]: ChatPromptDecision,
    [ChatPromptInputType.CONTINUE]: ChatPromptContinue,
};

const ChatPromptDispatcher = ({ disabled, onSubmit, prompt, response }) => {
    if (!prompt) return null;

    const inputType = prompt.input_type || prompt.action_type || ChatPromptInputType.BINARY;
    const PromptComponent = PromptComponentByInputType[inputType];

    if (!PromptComponent) {
        console.warn(`Unsupported chat prompt type: ${inputType}`);
        return null;
    }

    const [primaryAction, secondaryAction] = prompt.options || prompt.actions || [];
    if (inputType === ChatPromptInputType.BINARY && (!primaryAction || !secondaryAction)) return null;

    return (
        <ChatPromptFrame>
            <PromptComponent disabled={disabled} onSubmit={onSubmit} prompt={prompt} response={response} />
        </ChatPromptFrame>
    );
};

export default ChatPromptDispatcher;
